import type { enShell } from "./en.shell";

/** Russian for the shell (see `en.shell.ts`). Words from the boards Rail, Top, Foot, Settings. */
export const ruShell: Record<keyof typeof enShell, string> = {
  "nav.library": "Библиотека",
  "nav.offers": "Офферы",
  "nav.landers": "Ленды",
  "nav.partners": "Партнёрки",
  "nav.sources": "Источники",
  "nav.collapse": "Свернуть рейл",
  "nav.expand": "Развернуть рейл",
  "nav.shortcuts": "Навигация",
  "nav.crumbs": "Где вы",
  "crumb.edit": "Изменить",

  "appearance.title": "Оформление",
  "appearance.trigger": "Оформление: {tier}",
  "appearance.theme": "Тема",
  "appearance.theme.description": "Пока вы не выбрали, тема — как у бренда. Выбор хранится у вас в браузере",
  "appearance.theme.dark": "Тёмная",
  "appearance.theme.light": "Светлая",
  "appearance.theme.black": "Чёрная",
  "appearance.theme.system": "Как в системе",
  "appearance.theme.dark.hint": "для долгой работы",
  "appearance.theme.light.hint": "для яркого света",
  "appearance.theme.black.hint": "OLED, без серых плашек",
  "appearance.theme.system.hint": "сейчас: {tier}",
  "appearance.systemHint": "«Как в системе» следует за светлой или тёмной темой компьютера.",
  "appearance.density": "Плотность",
  "appearance.density.description": "Сколько строк влезает в таблицу. На MacBook 14 в компактной — 22 кампании без прокрутки",
  "appearance.density.compact": "Компактная",
  "appearance.density.default": "Обычная",
  "appearance.density.comfortable": "Просторная",
  "appearance.density.compact.metrics": "Строка 32 px · шрифт 13 px",
  "appearance.density.default.metrics": "Строка 36 px · шрифт 14 px",
  "appearance.density.comfortable.metrics": "Строка 44 px · шрифт 14 px",

  "search.title": "Поиск по трекеру",
  "search.empty": "Ничего не нашлось. Попробуйте другое слово.",
  "search.loading": "Ищем…",
  "search.group.create": "Создать",
  "search.group.places": "Разделы",
  "search.group.campaigns": "Кампании",
  "search.group.offers": "Офферы",
  "search.group.landers": "Ленды",
  "search.group.clicks": "Клик",
  "search.group.account": "Учётная запись",
  "search.click": "Клик {id}",
  "search.hint.choose": "выбрать",
  "search.hint.open": "открыть",
  "search.hint.close": "закрыть",

  "notFound.title": "Такого маршрута нет",
  "notFound.body": "Ссылка устарела или кампания удалена.",
  "notFound.cta": "К кампаниям",
};
